module.exports = __webpack_public_path__ + "img/s31.feef488b.jpg";